import React from 'react'

const SeperatorIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1542_16949)">
        <path
          d="M18.675 12.9998H4.5C4.21667 12.9998 3.97933 12.9038 3.788 12.7118C3.596 12.5205 3.5 12.2831 3.5 11.9998C3.5 11.7165 3.596 11.4788 3.788 11.2868C3.97933 11.0955 4.21667 10.9998 4.5 10.9998H18.675L17.275 9.5998C17.0917 9.41647 17.0043 9.18714 17.013 8.9118C17.021 8.63714 17.125 8.3998 17.325 8.1998C17.5083 8.01647 17.7417 7.9248 18.025 7.9248C18.3083 7.9248 18.5417 8.01647 18.725 8.1998L21.8 11.2998C21.9 11.3998 21.975 11.5081 22.025 11.6248C22.075 11.7415 22.0917 11.8665 22.075 11.9998C22.075 12.1331 22.0543 12.2581 22.013 12.3748C21.971 12.4915 21.9 12.5998 21.8 12.6998L18.7 15.7998C18.5 15.9998 18.2627 16.0955 17.988 16.0868C17.7127 16.0788 17.4833 15.9831 17.3 15.7998C17.1 15.5998 17 15.3621 17 15.0868C17 14.8121 17.0917 14.5831 17.275 14.3998L18.675 12.9998Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default SeperatorIcon
